import { FC } from 'react';
import {
  Center,
  Heading,
  VStack,
  Button,
  Box,
  Flex,
  Spinner,
} from '@chakra-ui/react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../consts/routes';
import { FaPlus } from 'react-icons/fa';
import TraitsTable from './Table';
import { useAdminCardDecksTraits } from '@olagg/api-hooks';

const Traits: FC = () => {
  const navigate = useNavigate();
  const { deck_id } = useParams();

  if (!deck_id) return null;

  const { data, isLoading, mutate } = useAdminCardDecksTraits(deck_id);

  if (isLoading) return <Spinner>Cargando...</Spinner>; 
  
  return (
    <Center w='full' pb={4}>
      <VStack color={'white'} w='full'>
        <Heading my={2}>Traits</Heading>
        <Flex w='full' alignItems='center' justifyContent='space-between'>
          <Button
            mt='2'
            variant="outlinedGradient"
            leftIcon={<FaPlus />}
            onClick={() => navigate(generatePath(ROUTES.CARD_DECKS.traits.create, { deck_id }))}
          >
            Nuevo Trait
          </Button>
        </Flex>

        {isLoading ? (
          <Spinner />
        ) : (
          <Box overflow="auto" mt={4} w="80vw" h="55vh">
            <TraitsTable traits={data?.traits || []} onUpdate={mutate} />
          </Box>
        )}
      </VStack>
    </Center>
  );
};

export default Traits;
export { CreateTrait } from './Create';
export { EditTrait } from './Edit';
